/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __awaiter, __extends, __generator } from "tslib";
import * as runtime from '../runtime';
import { ContentReleaseRequestToJSON, ContentRequestToJSON, ContentResponseFromJSON, ContentSearchRequestToJSON, PagedResponseOfContentListEntryFromJSON, } from '../models';
/**
 *
 */
var ContentRestControllerApi = /** @class */ (function (_super) {
    __extends(ContentRestControllerApi, _super);
    function ContentRestControllerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a new content <p> \'Permission#CREATE_CONTENT\' is required to access to this endpoint
     * Create a new content <p> \'Permission#CREATE_CONTENT\' is required to access to this endpoint
     */
    ContentRestControllerApi.prototype.createContentRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.contentRequest === null || requestParameters.contentRequest === undefined) {
                            throw new runtime.RequiredError('contentRequest', 'Required parameter requestParameters.contentRequest was null or undefined when calling createContent.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/contents",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: ContentRequestToJSON(requestParameters.contentRequest)
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return ContentResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create a new content <p> \'Permission#CREATE_CONTENT\' is required to access to this endpoint
     * Create a new content <p> \'Permission#CREATE_CONTENT\' is required to access to this endpoint
     */
    ContentRestControllerApi.prototype.createContent = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createContentRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete content <p> \'Permission#DELETE_CONTENT\' is required to access to this endpoint
     * Delete content <p> \'Permission#DELETE_CONTENT\' is required to access to this endpoint
     */
    ContentRestControllerApi.prototype.deleteContentRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.contentId === null || requestParameters.contentId === undefined) {
                            throw new runtime.RequiredError('contentId', 'Required parameter requestParameters.contentId was null or undefined when calling deleteContent.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/contents/{contentId}".replace("{".concat("contentId", "}"), encodeURIComponent(String(requestParameters.contentId))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete content <p> \'Permission#DELETE_CONTENT\' is required to access to this endpoint
     * Delete content <p> \'Permission#DELETE_CONTENT\' is required to access to this endpoint
     */
    ContentRestControllerApi.prototype.deleteContent = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteContentRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get content details <p> \'Permission#READ_CONTENT\' is required to access to this endpoint
     * Get content details <p> \'Permission#READ_CONTENT\' is required to access to this endpoint
     */
    ContentRestControllerApi.prototype.getContentRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.contentId === null || requestParameters.contentId === undefined) {
                            throw new runtime.RequiredError('contentId', 'Required parameter requestParameters.contentId was null or undefined when calling getContent.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/contents/{contentId}".replace("{".concat("contentId", "}"), encodeURIComponent(String(requestParameters.contentId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return ContentResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get content details <p> \'Permission#READ_CONTENT\' is required to access to this endpoint
     * Get content details <p> \'Permission#READ_CONTENT\' is required to access to this endpoint
     */
    ContentRestControllerApi.prototype.getContent = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getContentRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * List contents using pagination <p> \'Permission#READ_CONTENT\' is required to access to this endpoint
     * List contents using pagination <p> \'Permission#READ_CONTENT\' is required to access to this endpoint
     */
    ContentRestControllerApi.prototype.listContentsRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.size !== undefined) {
                            queryParameters['size'] = requestParameters.size;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/contents",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return PagedResponseOfContentListEntryFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * List contents using pagination <p> \'Permission#READ_CONTENT\' is required to access to this endpoint
     * List contents using pagination <p> \'Permission#READ_CONTENT\' is required to access to this endpoint
     */
    ContentRestControllerApi.prototype.listContents = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listContentsRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Patch content (partial update). The patch request do not unset any value by setting null on a certain field. To unset any value use (PUT) update method. <p> \'Permission#UPDATE_CONTENT\' is required to access to this endpoint. A content may update only itself.
     * Patch content (partial update).
     */
    ContentRestControllerApi.prototype.patchContentRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.contentId === null || requestParameters.contentId === undefined) {
                            throw new runtime.RequiredError('contentId', 'Required parameter requestParameters.contentId was null or undefined when calling patchContent.');
                        }
                        if (requestParameters.contentRequest === null || requestParameters.contentRequest === undefined) {
                            throw new runtime.RequiredError('contentRequest', 'Required parameter requestParameters.contentRequest was null or undefined when calling patchContent.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/contents/{contentId}".replace("{".concat("contentId", "}"), encodeURIComponent(String(requestParameters.contentId))),
                                method: 'PATCH',
                                headers: headerParameters,
                                query: queryParameters,
                                body: ContentRequestToJSON(requestParameters.contentRequest)
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return ContentResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Patch content (partial update). The patch request do not unset any value by setting null on a certain field. To unset any value use (PUT) update method. <p> \'Permission#UPDATE_CONTENT\' is required to access to this endpoint. A content may update only itself.
     * Patch content (partial update).
     */
    ContentRestControllerApi.prototype.patchContent = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.patchContentRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Release / block content <p> \'Permission#RELEASE_CONTENT\' is required to access to this endpoint
     * Release / block content <p> \'Permission#RELEASE_CONTENT\' is required to access to this endpoint
     */
    ContentRestControllerApi.prototype.releaseContentRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.contentId === null || requestParameters.contentId === undefined) {
                            throw new runtime.RequiredError('contentId', 'Required parameter requestParameters.contentId was null or undefined when calling releaseContent.');
                        }
                        if (requestParameters.contentReleaseRequest === null || requestParameters.contentReleaseRequest === undefined) {
                            throw new runtime.RequiredError('contentReleaseRequest', 'Required parameter requestParameters.contentReleaseRequest was null or undefined when calling releaseContent.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/contents/{contentId}/release".replace("{".concat("contentId", "}"), encodeURIComponent(String(requestParameters.contentId))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: ContentReleaseRequestToJSON(requestParameters.contentReleaseRequest)
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return ContentResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Release / block content <p> \'Permission#RELEASE_CONTENT\' is required to access to this endpoint
     * Release / block content <p> \'Permission#RELEASE_CONTENT\' is required to access to this endpoint
     */
    ContentRestControllerApi.prototype.releaseContent = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.releaseContentRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Search contents using search request and pagination  \'Permission#READ_LOCATION\' is required to access to this endpoint
     * Search contents using search request and pagination  \'Permission#READ_LOCATION\' is required to access to this endpoint
     */
    ContentRestControllerApi.prototype.searchContentsRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.contentSearchRequest === null || requestParameters.contentSearchRequest === undefined) {
                            throw new runtime.RequiredError('contentSearchRequest', 'Required parameter requestParameters.contentSearchRequest was null or undefined when calling searchContents.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.size !== undefined) {
                            queryParameters['size'] = requestParameters.size;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/contents/search",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: ContentSearchRequestToJSON(requestParameters.contentSearchRequest)
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return PagedResponseOfContentListEntryFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Search contents using search request and pagination  \'Permission#READ_LOCATION\' is required to access to this endpoint
     * Search contents using search request and pagination  \'Permission#READ_LOCATION\' is required to access to this endpoint
     */
    ContentRestControllerApi.prototype.searchContents = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.searchContentsRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update content <p> \'Permission#UPDATE_CONTENT\' is required to access to this endpoint
     * Update content <p> \'Permission#UPDATE_CONTENT\' is required to access to this endpoint
     */
    ContentRestControllerApi.prototype.updateContentRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.contentId === null || requestParameters.contentId === undefined) {
                            throw new runtime.RequiredError('contentId', 'Required parameter requestParameters.contentId was null or undefined when calling updateContent.');
                        }
                        if (requestParameters.contentRequest === null || requestParameters.contentRequest === undefined) {
                            throw new runtime.RequiredError('contentRequest', 'Required parameter requestParameters.contentRequest was null or undefined when calling updateContent.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/contents/{contentId}".replace("{".concat("contentId", "}"), encodeURIComponent(String(requestParameters.contentId))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: ContentRequestToJSON(requestParameters.contentRequest)
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return ContentResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update content <p> \'Permission#UPDATE_CONTENT\' is required to access to this endpoint
     * Update content <p> \'Permission#UPDATE_CONTENT\' is required to access to this endpoint
     */
    ContentRestControllerApi.prototype.updateContent = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateContentRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return ContentRestControllerApi;
}(runtime.BaseAPI));
export { ContentRestControllerApi };
